import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { Router } from '@angular/router';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { IsTabletAndMobileDirective } from 'src/app/directves/Is-tablet-and-mobile.directive.ts';
import { SaveNameListComponent } from 'src/app/features/create-questionnaire-page/component/question-form/components/save-name-list/save-name-list.component';
import { QuestionnairesGridStore } from 'src/app/features/questionnaires/store/questionnairesGrid-store';
import { EQuestionnaireStatus, QuestionnaireRow } from 'src/app/models/questionnaireGrid.model';
import { EReplyStatus, Recipient } from 'src/app/models/recipients.model';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { GlobalStore } from 'src/app/store/global-store';
import { ContactCircleComponent } from '../../../questionnaire-data/components/contact-circle/contact-circle.component';
import { DistributionRecipientsComponent } from '../distribution-recipients/distribution-recipients.component';
import { QuestionnaireStatusToUserComponent } from '../questionnaire-status-to-user/questionnaire-status-to-user.component';
import { QuestionnaireStatusComponent } from '../questionnaire-status/questionnaire-status.component';
import { QuestionnairesMenuItemComponent } from "../questionnaires-menu-item/questionnaires-menu-item.component";
import { RecipientsReplyComponent } from '../recipients-reply/recipients-reply.component';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { ExtraDetailsComponent } from "../extra-details/extra-details.component";
import { environment } from 'src/environment';
import { StatusApprovalFilterComponent } from "src/app/shared/components/status-approval-filter/status-approval-filter.component";
import { QuestionnaireStatusFlowComponent } from "../../../questionnaire-status-flow/questionnaire-status-flow.component";

@Component({
    selector: 'que-questionnaires-list-item',
    templateUrl: './questionnaires-list-item.component.html',
    styleUrls: ['./questionnaires-list-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, QuestionnaireStatusComponent, QuestionnaireStatusToUserComponent, MatButtonModule,
        MatMenuModule, TranslateDirective, TranslatePipe, QuestionnairesMenuItemComponent, DistributionRecipientsComponent, QueDatePipe, QuestionnaireStatusFlowComponent, ExtraDetailsComponent]
})
export class QuestionnairesListItemComponent implements OnInit {
  #questionnaireGridStore = inject(QuestionnairesGridStore);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  #globalStore = inject(GlobalStore);
  #router = inject(Router)
  @Input()
  questionnaire?: QuestionnaireRow;
  @Input()
  isByFolders = false;
  @Input()
  isBottom = false;
  isRoleAdmin$ = toSignal(inject(GlobalStore).isRoleAdmin$);
  isDisplayUser$ = toSignal(this.#manipulationsToolbarStore.isDisplayUser$);
  isGeneralQuestionnaires$ = toSignal(this.#manipulationsToolbarStore.isGeneralQuestionnaires$);
  isMyQuestionnaires$ = toSignal(this.#manipulationsToolbarStore.isMyQuestionnaires$);
  currentQuestionnaire$ = toSignal(this.#questionnaireGridStore.currentQuestionnaire$);
  users?: Recipient[] = [];
  enumQStatus = EQuestionnaireStatus;
  countAnswered?: number;
  countAllRecipients?: number;
  enumReplyStatus = EReplyStatus;
  #dialog = inject(MatDialog)
  colorDefault = "#1390CF";
  isExpenseEnv = environment.featurs.expense;


  ngOnInit(): void {
    this.users = [
      ...(this.questionnaire?.recipients?.users ?? []),
      ...(this.questionnaire?.recipients?.groups?.map(x => x.users?.map(y => y)) ?? []),
    ].flat() as Recipient[];

    this.countAllRecipients = this.users.length;
    this.countAnswered = this.users.filter(x => x.statusReply == this.enumReplyStatus.Finished).length;
  }
  //every change in the func hear - need do also in card component
  edit() {
    this.#router.navigate([`create`, `${this.questionnaire?.id}`])
  }
  duplicate(event: Event) {
    event.stopPropagation();
    this.#dialog.open(SaveNameListComponent,
      {
        autoFocus: false,
        data: {
          isDuplicateQuestionnairePopup: true,
          name: this.questionnaire?.name
        }
      }
    ).afterClosed()
      .subscribe((resultFromPopUp: string) => {
        if (resultFromPopUp) {
          this.#questionnaireGridStore.duplicateQuestionnaire({ id: this.questionnaire?.id ?? 0, name: resultFromPopUp })
        }
      })
  }

  navToData() {
    this.#router.navigate(['data', `${this.questionnaire?.id}`]);
  }
  view() {
    if (this.questionnaire?.guidToUser) {
      this.#router.navigate(['viewAnswers', this.questionnaire.guidToUser, 0]);
    }
  }
  answerIt(event?: Event) {
    event?.stopPropagation();
    if (this.questionnaire?.statusToUser == EReplyStatus.Template) {
      this.#router.navigateByUrl(
        `/answer/questionnaire/${this.questionnaire?.id}?unauthorized=true`
      );
    }
    else if (this.questionnaire?.guidToUser) {
      this.#router.navigate(['answer', `${this.questionnaire?.guidToUser}`])
    }
  }

  questionnaireClick() {
    if (!this.isDisplayUser$()) {
      if (this.questionnaire?.status == EQuestionnaireStatus.Edit) {
        this.edit();
      }
      else {
        this.navToData();
      }
    }
    else {
      const submittedStatuses = [
        this.enumReplyStatus.Finished,
        this.enumReplyStatus.PendingApproval,
        this.enumReplyStatus.Rejected,
        this.enumReplyStatus.Approved,
      ];
      if (this.questionnaire?.statusToUser != null && submittedStatuses.includes(this.questionnaire.statusToUser)) {
        this.view();
      }
      else {
        this.answerIt();
        this.#globalStore.updateIsOpenStatusFlow(false);
      }
    }
  }
}
